import { Routes } from '@angular/router';
import { publicRoutes } from "./public/public.routes";
import { secureRoutes } from "./secure/secure.routes";

export const routes: Routes = [
  ...publicRoutes,
  ...secureRoutes,
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'secure',
  },
  { path: '**', redirectTo: 'secure' },
];
